<!--  -->
<template>
  <div>
    <div class="div_startPOIName">
      <i class="i_startPOIName"></i>
      <span>{{startPOIName}}</span>
    </div>

    <ul class="ul_segmentItems">
      <li
        class="li_segmentItem"
        v-for="segmentItem in filterSegmentItems"
        :key="segmentItem.id"
        @click="_segmentItemClickHandler(segmentItem)"
      >
        <div style="display:flex">
          <i
            v-if="segmentItem.itemType==1"
            class="i_walk"
          ></i>
          <i
            v-if="segmentItem.itemType==2"
            class="i_bus"
          ></i>
          <i
            v-if="segmentItem.itemType==3"
            class="i_subway"
          ></i>

          <span class="span_segment">
            <span>{{segmentItem.segmentDescInfo.prefixDesc}}</span>

            <span>
              <a
                class="a_segment_endName"
                @click="_segmentEndNameClickHandler(segmentItem)"
              >{{segmentItem.segmentDescInfo.endName}}</a>
            </span>
            <span>{{segmentItem.segmentDescInfo.suffixDesc}}</span>
          </span>
          <span class="span_segment_stationCount">{{segmentItem.stationCountDesc}}</span>
        </div>

        <i class="route_point"></i>
      </li>
    </ul>

    <div class="div_endPOIName">
      <i class="i_endPOIName"></i>
      <span>{{endPOIName}}</span>
    </div>

  </div>
</template>

<script>
// import { SegmentItem } from "../../../utility/tdtService/BusTransfer/Model/SegmentItem.js";
import { UCRouteEvent } from "./UCRouteJs.js";
import { SegmentItems } from "../../../utility/tdtService/BusTransfer/Model/SegmentItems.js";
import { SegmentType } from "../../../utility/tdtService/BusTransfer/Model/SegmentType";

export default {
  name: "UCBusSegmentItems",
  data() {
    return {
      ucControl: {
        clickIsSegmentEndName: false
      },

      segmentItems: new SegmentItems(),

      filterSegmentItems: new Array(),

      startPOIName: "",

      endPOIName: ""
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    init() {
      if (!this.segmentItems) return;

      //移除换乘线

      let filterTypes = new Array();
      filterTypes.push(SegmentType.Bus);
      filterTypes.push(SegmentType.Subway);
      filterTypes.push(SegmentType.Walk);

      this.filterSegmentItems = this.segmentItems.filterBySegmentTypes(
        filterTypes
      );

      if (this.filterSegmentItems.length > 0) {
        let startSegmentItem = this.filterSegmentItems[0];
        startSegmentItem.setStationStartName(this.startPOIName);
        startSegmentItem.resetSegmentDesc();

        let endSegmentItem = this.filterSegmentItems[
          this.filterSegmentItems.length - 1
        ];
        endSegmentItem.setStationEndName(this.endPOIName);
        endSegmentItem.resetSegmentDesc();
      }
    },

    off_segmentItemClick(callback) {
      if (callback) {
        this.$off(UCRouteEvent.UCBusSegmentItems_segmentItemClick, callback);
      }
    },

    off_segmentEndNameClick(callback) {
      if (callback) {
        this.$off(UCRouteEvent.UCBusSegmentItems_segmentEndNameClick, callback);
      }
    },

    on_segmentItemClick(callback) {
      if (callback) {
        this.$on(UCRouteEvent.UCBusSegmentItems_segmentItemClick, callback);
      }
    },

    on_segmentEndNameClick(callback) {
      if (callback) {
        this.$on(UCRouteEvent.UCBusSegmentItems_segmentEndNameClick, callback);
      }
    },

    _segmentItemClickHandler(segmentItem) {
      if (this.ucControl.clickIsSegmentEndName) {
        this.ucControl.clickIsSegmentEndName = false;
      } else {
        this.$emit(
          UCRouteEvent.UCBusSegmentItems_segmentItemClick,
          segmentItem
        );
      }
    },

    _segmentEndNameClickHandler(segmentItem) {
      this.ucControl.clickIsSegmentEndName = true;

      this.$emit(
        UCRouteEvent.UCBusSegmentItems_segmentEndNameClick,
        segmentItem
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.ul_segmentItems {
  padding: 3px 0px;
}

.li_segmentItem {
  display: flex;
  flex-direction: column;

  position: relative;
  cursor: pointer;
  height: 44px;
  margin: 0;
  list-style: none;
  line-height: 44px;
}

.i_bus {
  background: url("../../../assets/onlineMap/icon.png") #fff;
  background-position: -148px -183px;
  width: 14px;
  height: 16px;
  display: inline-block;

  margin-right: 10px;
  margin-left: 1px;
  background-repeat: no-repeat;
  margin-top: 4px;
}

.i_subway {
  background: url("../../../assets/onlineMap/icon.png") #fff;
  background-position: -220px -184px;
  width: 12px;
  height: 16px;
  display: inline-block;

  margin-right: 10px;
  margin-left: 1px;
  background-repeat: no-repeat;
  // float: left;
  margin-top: 4px;
}

.i_walk {
  background: url("../../../assets/onlineMap/icon.png") #fff;
  background-position: -242px -184px;

  width: 9px;
  height: 16px;
  display: inline-block;

  margin-top: 4px;
  margin-left: 2px;
  margin-right: 12px;
}

.span_segment {
  width: 225px;
  position: relative;
  cursor: pointer;
  height: 22px;
  margin: 0;
  padding: 0;
  list-style: none;
  line-height: 22px;
}

.span_segment_stationCount {
  height: 22px;
  margin-left: auto;
  margin-right: auto;
  line-height: 22px;

  float: right;
  
  color: #999;
}

.a_segment_endName {
  color: #2f87eb;
}

.i_startPOIName {
  background: url("../../../assets/onlineMap/icon.png") #fff;
  background-position: -512px -154px;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  display: inline-block;
  margin-top: 3px;
  margin-right: 5px;
}

.i_endPOIName {
  background: url("../../../assets/onlineMap/icon.png") #fff;

  background-position: -536px -154px;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  display: inline-block;
  margin-top: 3px;
  margin-right: 5px;
}

.route_point {
  background: url("../../../assets/onlineMap/icon.png") #fff;
  background-position: -335px -188px;
  width: 4px;
  height: 12px;

  position: absolute;
  left: 3px;
  top: 24px;
  margin-right: 10px;
  margin-left: 1px;
}

.i_route_point {
  background: url("../../../assets/onlineMap/icon.png") #fff;
  background-position: -335px -188px;
  width: 4px;
  height: 12px;
  background-repeat: no-repeat;
  display: inline-block;
  left: 15px;
  top: 24px;
  position: absolute;
}

.div_startPOIName {
  padding: 9px 0px;
  display: flex;
}

.div_endPOIName {
  padding: 9px 0px;
  display: flex;
}
</style>